export class ProcessesType {
    processID: number;
    description: string;
}